import React, { useEffect, useState } from 'react';
import { DeliverySchedulePayload } from './types';
import SurgeScheduleSection from '../surge-tabs/surge-schedule';
import { PolygonSurgeTabProps } from '../surge-tabs/types';
import { toast } from 'react-toastify';
import { Switch, ToastMessage } from '@cokitchen/cokitchen-components';
import { ALL_POLYGONS_ID } from 'utils/constants';
import { apiService } from 'utils/api';

const DeliverySettingsSchedule: React.FC<PolygonSurgeTabProps> = ({
  confirm,
  setLoading,
  onClose,
  cokitchen_polygon_id
}) => {
  const [value, setValue] = useState({} as DeliverySchedulePayload);

  const updateDeliveryOptions = async () => {
    try {
      const data: DeliverySchedulePayload = { ...value };

      if (cokitchen_polygon_id !== ALL_POLYGONS_ID) {
        data.cokitchen_polygon_id = cokitchen_polygon_id;
      }
      await apiService.post('logistics/super-admin/delivery-settings/polygon/schedule', { data });
      return true;
    } catch {
      return false;
    }
  };

  useEffect(() => {
    if (confirm === 'Schedule') {
      (async () => {
        try {
          setLoading(true);
          await updateDeliveryOptions();
          toast(<ToastMessage type='success' message='Updated successfully' />);
          onClose();
        } catch (error) {
          toast(
            <ToastMessage type='error' message='There was an error updating delivery settings' />
          );
        } finally {
          setLoading(false);
        }
      })();
    }
  }, [confirm]);

  return (
    <div className='mt-6'>
      <div className='flex gap-x-4'>
        <Switch
          label='Turn off delivery'
          active={value.delivery}
          onChange={() => setValue({ ...value, delivery: !value.delivery })}
        />
        <Switch
          label='Turn off pickup'
          active={value.pickup}
          onChange={() => setValue({ ...value, pickup: !value.pickup })}
        />
      </div>
      <SurgeScheduleSection
        key={cokitchen_polygon_id}
        value={value}
        setValue={(newVal) => setValue({ ...value, ...newVal })}
      />
    </div>
  );
};

export default DeliverySettingsSchedule;
